import { http } from '@/utils'

const state = {
  dependencies: []
}

const getters = {
  uri: (state, getters, rootState) => `applications/${rootState.applications.single.id}/dependencies`
}

const actions = {
  async getDependencies ({ commit, getters }, params) {
    const response = await http.get(getters.uri, { params })

    commit('SET_DEPENDENCIES', response.data.data)
  },

  resetDependencies ({ commit }) {
    commit('SET_DEPENDENCIES', [])
  }
}

const mutations = {
  SET_DEPENDENCIES (state, dependencies) {
    state.dependencies = dependencies
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
